import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type MessageResult } from "../../api/generated/data-contracts";

interface GlobalChatState {
  messages: MessageResult[];
  isLoading: boolean;
  unseenChats: number;
  lastMessage: MessageResult | null;
}

const initialState: GlobalChatState = {
  messages: [],
  isLoading: false,
  unseenChats: 0,
  lastMessage: null
};

const globalChatSlice = createSlice({
  name: "globalChat",
  initialState,
  reducers: {
    setGlobalMessages(state, action: PayloadAction<MessageResult[]>) {
      state.messages = action.payload;
      state.lastMessage = action.payload[0] ?? null;
    },
    addGlobalMessage(state, action: PayloadAction<MessageResult>) {
      const existingIndex = state.messages.findIndex(
        (msg) => msg.uuid === action.payload.uuid
      );

      if (existingIndex !== -1) {
        state.messages[existingIndex] = action.payload;
      } else {
        state.messages.push(action.payload);
      }
    },
    removeGlobalMessage(state, action: PayloadAction<number>) {
      state.messages = state.messages.filter(
        (msg) => msg.id !== action.payload
      );
    },
    setGlobalChatLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setUnseenChats(
      state,
      action: PayloadAction<number | ((prev: number) => number)>
    ) {
      if (typeof action.payload === "function") {
        state.unseenChats = action.payload(state.unseenChats);
      } else {
        state.unseenChats = action.payload;
      }
    }
  }
});

export const {
  setGlobalMessages,
  addGlobalMessage,
  removeGlobalMessage,
  setGlobalChatLoading,
  setUnseenChats
} = globalChatSlice.actions;

export const globalChatReducer = globalChatSlice.reducer;
